export default "__VITE_PUBLIC_ASSET__b74d0a46__"